import React from "react";
import "./area.css";

class AreaComponent extends React.Component {
    render() {
        return (
            <div id="area">
                <div className="container">
                    <h2>พื้นที่ให้บริการ</h2>
                    <div id="area-content">
                        <div>
                            <h3>Bangkok</h3>
                            <ul>
                                <li>All districts</li>
                            </ul>
                        </div>
                        <div>
                            <h3>North</h3>
                            <ul>
                                <li className="active">DC Nakhon Sawan</li>
                                <li>Chai Nat</li>
                                <li>Nakhon Sawan</li>
                                <li>Uthai Thani</li>
                                <li>Tak</li>
                                <li>Kamphaeng Phet</li>
                                <li className="active">DC Phitsanulok</li>
                                <li>Phichit</li>
                                <li>Phitsanulok</li>
                                <li>Sukhothai</li>
                                <li>Uttaradit</li>
                                <li>Phetchabun</li>
                                <li className="active">DC Chiang Mai</li>
                                <li>Phrae</li>
                                <li>Lampang</li>
                                <li>Chiang Mai</li>
                                <li>Lamphun</li>
                                <li>Nan</li>
                                <li>Phayao</li>
                                <li>Chiang Rai</li>
                                <li>Mae Hong Son</li>
                            </ul>
                        </div>
                        <div>
                            <h3>Central</h3>
                            <ul>
                                <li>Ang Thong</li>
                                <li>Ayuthaya</li>
                                <li>Chachoengsao</li>
                                <li>Chanthaburi</li>
                                <li>Chon Buri</li>
                                <li>Kanchanaburi</li>
                                <li>Lop Buri</li>
                                <li>Nakhon Nayok</li>
                                <li>Nakhon Pathom</li>
                                <li>Phetchaburi</li>
                                <li>Prachin Buri</li>
                                <li>Ratchaburi</li>
                                <li>Rayong</li>
                                <li>Sa Kaeo</li>
                                <li>Samut Sakhon</li>
                                <li>Samut Songkhram</li>
                                <li>Saraburi</li>
                                <li>Sing Buri</li>
                                <li>Suphan Buri</li>
                                <li>Trat</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AreaComponent;
